import { useEffect } from 'react';

import type { Env } from '@bank/utils';

import { navigateToExternal } from './utils';

export interface ExternalNavigationProps {
  url: string;
  env?: Env;
}

export const ExternalNavigation = ({ url, env }: ExternalNavigationProps) => {
  useEffect(() => {
    navigateToExternal(url, { env });
  }, [url, env]);

  return null;
};
